<template>
  <div class="resume">
    <div class="resume__top">
      <div class="resume__top__arrow" @click="goToPrevStep">
        <sm-icon class="resume__top__arrow__green-icon" size="medium" icon="arrow-left"/>
      </div>
      <div class="resume__top__title">Confirma la información y revisa que tu selección esté correcta</div>
    </div>

    <div class="resume__text">Usuarios que cumplen con los siguientes filtros y serán verificados</div>

    <ActiveFilter></ActiveFilter>

    <div class="resume__text resume__text--extra-margin-top">Obtendrás la siguiente información de contacto de la empresa una vez haya manifestado interés</div>
    <div class="resume__example">
      <div class="resume__example__header">
        <div class="resume__example__header__text">
          <div class="resume__example__header__text__circle">Datos de empresa</div>
        </div>
        <div class="resume__example__header__text">
          <div class="resume__example__header__text__down">Empresa</div>
        </div>
        <div class="resume__example__header__text">
          <div class="resume__example__header__text__down">Contacto</div>
        </div>
      </div>

      <div class="resume__example__container">
        <div class="resume__example__container__item resume__example__container__item--gray">Nombre de empresa</div>
        <div class="resume__example__container__item">Capsule Corp</div>

        <div class="resume__example__container__item resume__example__container__item--gray">NIT</div>
        <div class="resume__example__container__item">11.338.854-3</div>

        <div class="resume__example__container__item resume__example__container__item--gray">Facturación mensual</div>
        <div class="resume__example__container__item">$500'000.000 COP</div>

        <div class="resume__example__container__item resume__example__container__item--gray">País</div>
        <div class="resume__example__container__item">Colombia</div>

        <div class="resume__example__container__item resume__example__container__item--gray">Ciudad</div>
        <div class="resume__example__container__item">Medellín</div>

        <div class="resume__example__container__item resume__example__container__item--gray">Sector</div>
        <div class="resume__example__container__item">Ingeniería</div>

        <div class="resume__example__container__item resume__example__container__item--gray">Persona</div>
        <div class="resume__example__container__item">Jurídica</div>

        <div class="resume__example__container__item resume__example__container__item--gray">Tiempo en Alegra</div>
        <div class="resume__example__container__item">24 meses</div>

        <div class="resume__example__container__item--contact">
          <div class="resume__example__container__item--contact__profile">
            <div class="resume__example__container__item--contact__profile__pic">J</div>
            <div class="resume__example__container__item--contact__profile__data">
              <div class="resume__example__container__item--contact__profile__data__name">Juan Fernando Gómez</div>
              <div class="resume__example__container__item--contact__profile__data__headline">Administrador de operaciones</div>
            </div>
          </div>

          <div class="resume__example__container__item--contact__label">E-mail</div>
          <div class="resume__example__container__item--contact__text">juan.gomez@capsulecorp.com</div>

          <div class="resume__example__container__item--contact__label">Celular</div>
          <div class="resume__example__container__item--contact__text">+57 912834756</div>

          <div class="resume__example__container__item--contact__label">Teléfono</div>
          <div class="resume__example__container__item--contact__text">1234567</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActiveFilter from '../ActiveFilter'

export default {
  name: 'Resume',
  components: {
    ActiveFilter
  },
  data () {
    return {
      showVersion: false,
      showSector: false,
      showKindOfPerson: false
    }
  },
  computed: {
    maybeUsers () {
      return this.$store.getters.maybeUsers
    },
    aqlFilter () {
      return this.$store.getters.aqlFilter
    },
    filter () {
      const { version, sector, kindOfPerson } = this.aqlFilter
      const { opts: { time: { months } } } = this.$store.getters.filter

      return {
        ubication: version ? `${version[0]} (${version.length})` : '-',
        sector: sector ? sector.length : '-',
        person: this.person(kindOfPerson[0]),
        months: months.show ? months.key : '-'
      }
    }
  },
  methods: {
    goToPrevStep () {
      this.$store.commit('goToPrevStep')
    },
    person (kindOfPerson) {
      return kindOfPerson ? kindOfPerson === '1' ? 'Juridica' : 'Natural' : '-'
    }
  }
}
</script>

<style>
.resume__top {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
}

.resume__top__arrow {
  color: #00b19d;
  font-size: large;
  font-weight: bold;
  line-height: 2;
  text-align: center;

  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  height: fit-content;
  width: 37px;
}

.resume__top__arrow__green-icon {
  color: #00b19d;
}

.resume__top__arrow__green-icon:hover {
  opacity: 0.7;
}

.resume__top__title {
  color: #00535e;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  width: calc(100% - 90px);
}

.resume__text {
  color: #595959;
  font-size: 14px;
  font-weight: 400;
  text-align: center;

  margin-bottom: 10px;
  margin-top: 20px;
  width: 100%;
}

.resume__text--extra-margin-top {
  color: #595959;
  font-size: 14px;
  font-weight: 400;
  text-align: center;

  margin-bottom: 10px;
  margin-top: 65px;
  width: 100%;
}

.resume__num-of-users {
  color: #00535e;
  font-weight: bold;

  border-color: #00535e;
  border-radius: 20px;
  border-style: solid;
  border-width: 1px;
  margin: 0 calc(50% - 82px);
  margin-bottom: 20px;
  padding: 3px 30px;
  width: 150px;
}

.resume__example {
  background-color: #ededed80;
  border-radius: 6px;
  margin: 0 75px;
  padding: 25px 7px;
}

.resume__example__header {
  display: grid;
  grid-gap: 2px;
  grid-template-columns: repeat(2, calc(50% - 122px)) 240px;
  padding: 0 2px;
}

.resume__example__header__text__circle {
  color: #ffffff;
  font-size: 11px;
  font-weight: 400;

  background-color: #00535e;
  border-radius: 20px;
  padding: 2px 20px;
  width: fit-content;
}

.resume__example__header__text {
  text-align: left;

  padding-left: 15px;
}

.resume__example__header__text__down {
  color: #00535e;
  font-size: 12px;
  font-weight: 400;
  line-height: 32px;

  height: 20px;
}

.resume__example__container {
  background-color: #cccccc;
  display: grid;
  grid-gap: 2px;
  grid-template-columns: repeat(2, calc(50% - 122px)) 240px;
  grid-template-rows: repeat(8, auto);
  margin-top: 5px;
  padding: 2px;
}

.resume__example__container__item {
  color: #00535e;
  font-size: 12px;
  line-height: 35px;
  text-align: left;

  background-color: #ffffff;
  height: 29px;
  padding-left: 15px;
}

.resume__example__container__item--gray {
  background-color: #f2f2f2;
}

.resume__example__container__item--contact {
  background-color: #ffffff;
  grid-column: 3/4;
  grid-row: 1/9;
}

.resume__example__container__item--contact__profile {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 5px 0;
}

.resume__example__container__item--contact__profile__pic {
  color: #ffffff;
  line-height: 35px;

  background-color: #4a90e2;
  border-radius: 50%;
  border-style: none;
  height: fit-content;
  width: 35px;
}

.resume__example__container__item--contact__profile__data__name {
  color: #00535e;
  font-size: 16px;
  font-weight: 100;
}

.resume__example__container__item--contact__profile__data__headline {
  color: #595959;
  font-size: 12px;
  font-weight: 100;
}

.resume__example__container__item--contact__label {
  color: #b3b3b3;
  font-size: 12px;
  font-weight: 100;
  text-align: left;

  margin-top: 15px;
  padding: 0 15px;
}

.resume__example__container__item--contact__text {
  color: #595959;
  font-size: 12px;
  font-weight: 100;
  text-align: left;

  padding: 0 15px;
}
</style>
